var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28494 5.69643C3.56507 3.02694 5.81585 1 8.5 1V1C11.1841 1 13.4349 3.02694 13.7151 5.69643L13.9892 8.30842C13.9926 8.34144 13.9944 8.35795 13.9961 8.3743C14.113 9.44564 14.4452 10.4823 14.9726 11.4221C14.9807 11.4365 14.9888 11.4509 15.0052 11.4798L15.563 12.4641C16.0823 13.3806 16.342 13.8388 16.2613 14.2115C16.2166 14.4181 16.1075 14.6053 15.9498 14.7461C15.6653 15 15.1386 15 14.0853 15H2.91472C1.86138 15 1.33471 15 1.0502 14.7461C0.892459 14.6053 0.783398 14.4181 0.738683 14.2115C0.658031 13.8388 0.917685 13.3806 1.43699 12.4641L1.99478 11.4798C2.01115 11.4509 2.01934 11.4365 2.02738 11.4221C2.55485 10.4823 2.88698 9.44564 3.00386 8.3743C3.00565 8.35795 3.00738 8.34144 3.01085 8.30842L3.28494 5.69643Z",
    stroke: "#2A2D34",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42111 15.4059C5.60272 16.1501 6.00289 16.8077 6.55957 17.2767C7.11625 17.7458 7.79832 18 8.5 18C9.20168 18 9.88375 17.7458 10.4404 17.2767C10.9971 16.8077 11.3973 16.1501 11.5789 15.4059",
    stroke: "#2A2D34",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.ea4e9fa4feea76292c6daf1b33482c94.svg";
export { ForwardRef as ReactComponent };